exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#app{background-color:#eff0f4}", "", {"version":3,"sources":["/workspace/src/views/settings/pages/ChangePassword.vue"],"names":[],"mappings":"AACA,KACE,wBAA0B,CAC3B","file":"ChangePassword.vue","sourcesContent":["\n#app {\n  background-color: #eff0f4;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aae927f0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/settings/pages/ChangePassword.vue
// module id = 5377
// module chunks = 94